// extracted by mini-css-extract-plugin
module.exports = {"container":"_9cc2","image":"_7312","subTitle":"_13bc","button":"_6774"};